module.exports = __webpack_public_path__ + "static/media/illustration-horn.889c7412.png";